import React, { ButtonHTMLAttributes } from 'react'

import { CTA } from 'goustouicomponents'

import css from './EnterPromoCodeManuallyButton.module.css'

type Props = {
  onClick: ButtonHTMLAttributes<Element>['onClick']
}

export const EnterPromoCodeManuallyButton = ({ onClick }: Props) => (
  <div className={css.container}>
    <CTA
      size="medium"
      isDarkTheme
      testingSelector="enterPromoCodeManuallyButton"
      onClick={onClick}
      isFullWidth
    >
      I have a discount code to&nbsp;enter
    </CTA>
  </div>
)
